
export const COLORS={
    primaryColor:"#254BA1",
    overlayColor:"lightgrey",
    secondaryColor:"#254BA1",
    whiteColor:"#fff",
    lightgreenColor:"#b7b9e1ff",
    blackColor:"#000"
    
}

export const fontFamilyAll="Nunito Sans";